import swal from "sweetalert";

export const sendDynamicEmailsSwift = async (
  receiverEmails,
  subject,
  body,
  ccEmails = []
) => {
  const token = JSON.parse(localStorage.getItem("slotbook"));

  const getUserId = token?.userId;

 
  const accessToken = token?.accessToken;

  try {
    let data = {
      receiver_emails: receiverEmails.map((email) => email),
      subject: subject,
      body: body,
      cc_emails: ccEmails,
    };

    const response = await fetch(
      // "https://apipostman.onlinecu.in/exam_sch/api/send-email/",
      // "https://apipostman.onlinecu.in/exam_sch/api/send-email/",
      `https://apipostman.onlinecu.in/exam_sch/api/send-email/?user_id=${getUserId}`,
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      }
    );

 

    if (response.status === 401) {
      swal({
        title: "Session Expired",
        text: "Your session has expired. Please login again.",
        icon: "warning",
        button: "Login",
      }).then(() => {
        localStorage.clear();
        window.location.href = "/login";
      });
      return false;
    }

    if (response.ok) {
      const resultCount = await response.json();
      if (response.status === 202) {
        swal({
          title: resultCount?.message || "Bulk email started",
          text: `${resultCount?.total_queued ?? ""} emails queued. You will receive a report at your email when complete.`,
          icon: "success",
          button: "Close",
        });
      } else {
        swal({
          title: "Emails sent successfully!!",
          icon: "success",
          button: "Close",
        });
      }
      return true;
    } else {
      const errorData = await response.json();

      swal({
        title: errorData?.message || "Error sending emails",
        icon: "warning",
        button: "Close",
      });

      return false;
    }
  } catch (error) {
    console.error("Error sending emails:", error);
    swal({
      title: "Error sending emails",
      text: error?.message,
      icon: "error",
      button: "Close",
    });

    return false;
  }
};
